import React from "react";
import * as RB from "react-bootstrap";
import { Link } from "react-router-dom";

function View(props) {
  const { rowData, onBackClick } = props;
  console.log(rowData);
  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow">
          <RB.Card.Header className="border-0">
            <h5>View</h5>
            <div className="card-header-action">
              <Link className="btn btn-underline me-2" onClick={onBackClick}>
                Back
              </Link>
            </div>
          </RB.Card.Header>
          <RB.Card.Body>
            <RB.Row className="mb-3">
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Installation Certificate No
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.installation_certificate_no || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Plant Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.plant_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Location Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.location_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Equipment Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.equipment_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Make / Brand
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.brand || "-"}
                </p>
              </RB.Col>

              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  No. Of Equipment
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.equipment_no || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  PO NO.
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.po_no || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  CER Number
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.cer_no || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  PO Date
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.po_date || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  PO Value
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.po_value || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Supplier Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.supplier_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Asset Code No
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.asset_code_no || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Asset Tag No
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.asset_tag_no || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Engineering Grouping Code
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.engineering_group_code || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Trial Report
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.trial_report || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Trial Completion Date
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.trial_completion_date || "-"}
                </p>
              </RB.Col>

              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Production Capitalisation Date
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.production_capitalisation_date || "-"}
                </p>
              </RB.Col>

              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Useful Life
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.useful_life_assets || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Depreciation Rate
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.depraciation_rate || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  COA Description
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.COA_description || "-"}
                </p>
              </RB.Col>
            </RB.Row>
            <RB.Row className="mb-3">
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Attachment
                </span>
                <div className="fw-medium text-sm fw-semibold">
                  {rowData.attechPath ? (
                    <a
                      href={rowData.attechPath}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={rowData.attechPath}
                        alt="Attachment"
                        style={{
                          maxWidth: "100%",
                          height: "auto",
                          cursor: "pointer",
                        }}
                      />
                    </a>
                  ) : (
                    "-"
                  )}
                </div>
              </RB.Col>
            </RB.Row>

            <h6>Post Installation</h6>
            <RB.Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Particulars</th>
                  <th>Conclusion</th>
                  <th>Remark</th>
                  <th>Signature</th>
                </tr>
              </thead>
              <tbody>
                {rowData?.post_installation.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.particulars}</td>
                    <td>{item.conclusion_check_list}</td>
                    <td>{item.remark}</td>
                    <td>{item.signature}</td>
                  </tr>
                ))}
              </tbody>
            </RB.Table>

            <h6>Safety Installation</h6>
            <RB.Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Particulars</th>
                  <th>Conclusion</th>
                  <th>Remark</th>
                  <th>Signature</th>
                </tr>
              </thead>
              <tbody>
                {rowData?.safety_installation.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.particulars}</td>
                    <td>{item.conclusion_check_list}</td>
                    <td>{item.remark}</td>
                    <td>{item.signature}</td>
                  </tr>
                ))}
              </tbody>
            </RB.Table>

            <h6>Invoice Data</h6>
            <RB.Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Supplier Name</th>
                  <th>Bill No</th>
                  <th>Date</th>
                  <th>Quantity</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {rowData?.invoice_data.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.supplier_name}</td>
                    <td>{item.bill_no}</td>
                    <td>{item.date}</td>
                    <td>{item.qty}</td>
                    <td>{item.amount}</td>
                  </tr>
                ))}
              </tbody>
            </RB.Table>

            <h6>SR Booking</h6>
            <RB.Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th>Item Description</th>
                  <th>Basic</th>
                  <th>BED</th>
                  <th>IGST</th>
                  <th>SGST</th>
                  <th>CGST</th>
                  <th>Capitalisation Value</th>
                </tr>
              </thead>
              <tbody>
                {rowData?.sr_booking.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.date}</td>
                    <td>{item.item_description}</td>
                    <td>{item.basic}</td>
                    <td>{item.bed}</td>
                    <td>{item.igst}</td>
                    <td>{item.sgst}</td>
                    <td>{item.cgst}</td>
                    <td>{item.capitalisation_value}</td>
                  </tr>
                ))}
              </tbody>
            </RB.Table>
          </RB.Card.Body>
        </RB.Card>
      </div>
    </>
  );
}

export default View;
